import { CloseOutline18Icon } from "@vygruppen/spor-icon-react";
import { ButtonTextContainer } from "features/CenterContent/shared/Tabs/TabsCenter";
import {
  ActiveTab,
  InActiveTab,
} from "features/CenterContent/shared/Tabs/TabsStyle";
import {
  BackupBusTab,
  useTabsContext,
} from "features/CenterContent/shared/Tabs/useTabsContext";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CrossButton } from "shared/components/buttons/CrossButton";
import { Text } from "shared/components/Spor";
import * as ROUTES from "shared/utils/routes";
import { useTheme } from "styled-components";

export const BackupBusTabElement = ({
  backupBusTabs,
  index,
}: {
  backupBusTabs: BackupBusTab;
  index: number;
}) => {
  const { activeIdTabs, setActiveIdTabs } = useTabsContext();
  const { backupBusId, backupTabId } = backupBusTabs;
  const { vehicleUuid } = useParams();
  const navigate = useNavigate();
  const selected = backupBusId === vehicleUuid;

  const TabElement = selected ? ActiveTab : InActiveTab;
  const theme = useTheme();
  return (
    <TabElement
      title={`${backupBusId}`}
      key={index}
      onClick={(event) => {
        event.preventDefault();
        if (backupBusId) {
          void navigate(
            generatePath(ROUTES.BACKUPBUS, {
              vehicleUuid: backupBusId,
            }),
          );
        }
      }}
      style={{
        padding: "4px 10px",
        borderRadius: "6px 6px 0px 0px",
      }}
    >
      <ButtonTextContainer>
        <Text variant="xs" margin="auto">
          {backupTabId || ""}
        </Text>
        <CrossButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (selected) {
              if (activeIdTabs.length === 1) {
                sessionStorage.removeItem("openTabs");
                void navigate(ROUTES.DASHBOARD);
              } else {
                const prevTabs = (activeIdTabs[index - 1] ||
                  activeIdTabs[index + 1]) as BackupBusTab;
                if (
                  prevTabs &&
                  prevTabs.type === "backupbus" &&
                  prevTabs.backupBusId
                ) {
                  void navigate(
                    generatePath(ROUTES.BACKUPBUS, {
                      vehicleUuid: prevTabs.backupBusId,
                    }),
                  );
                }
              }
            }
            setActiveIdTabs((prevArr: any) => {
              prevArr.splice(index, 1);
              return Array.from(prevArr);
            });
          }}
        >
          <CloseOutline18Icon color={theme.colorTextMain} marginLeft="4px" />
        </CrossButton>
      </ButtonTextContainer>
    </TabElement>
  );
};
